import React, { useEffect, useState } from 'react'
import { v2_all_user } from '../../../actions/v2/user';
import moment from 'moment';
import { getAuthHeader } from '../../../utils';
import axios from 'axios';
import SendReport from './sendReport';
import customAxios from '../../../customHook/customAxios';
import fileDownload from 'js-file-download';
import FileDropdownPreviewMenu from '../../common/FileDropdownPreviewMenu';

const Header = ({ data, saveAssignee, revision, revisions }) => {
    const [users, setUsers] = useState([]);
    const [assignedUsers, setAssignedUsers] = useState([]);
    useEffect(() => {
        v2_all_user().then((res) => {
            if (res.status) {
                setUsers(res.result)
            }
        })
    }, [])


    useEffect(() => {
        if (data?.assignee?.length) {
            const userIds = data.assignee.map(item => item.USER_ID);
            setAssignedUsers(userIds);
        } else {
            setAssignedUsers([]); // fallback to empty array if no assignees
        }
    }, [data]);


    const handleDownload = async (planId, revisionId) => {
        try {
            const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/document/zip/${planId}/${revisionId}`;
            let config = { responseType: 'blob' }
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await customAxios.get(downloadUrl, config);

            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', `plan_${planId}_revision_${revisionId}_files.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Download failed:', error?.response?.data || error.message);
            alert("Download failed. Please check if the document has valid files or contact support.");
        }
    };

    const handleDownloadFile = async (planId, revisionId, fileName) => {
        try {
            const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/planApproval/document/download/${planId}/${revisionId}/${encodeURIComponent(fileName)}`;
            let config = { responseType: 'blob' };
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await customAxios.get(downloadUrl, config);
            fileDownload(response.data, fileName);
        } catch (error) {
            console.error('Download failed:', error?.response?.data || error.message);
            alert("Download failed. Please check if the document has valid files or contact support.");
        }
    };

    const revisionId = revision?.ID;


    return (
        <div className="plan-approval-top-box">
            <div className="info-about-modle-box">
                <div className="mod-box-info">
                    <h5>DFA No.</h5>
                    <p>{data.ID}</p>
                </div>
                <div className="mod-box-info">
                    <h5>Type</h5>
                    <p>{data.PLAN_TYPE}</p>
                </div>
                <div className="mod-box-info">
                    <h5>Category</h5>
                    <p>{data.CATEGORY_NAME}</p>
                </div>
                <div className="mod-box-info">
                    <h5>Plan Number</h5>
                    <p className="cat-para">{data.PLAN_NUMBER}</p>
                </div>
                <div className="mod-box-info">
                    <h5>Assigned  <i className='bx bx-edit'
                        data-bs-toggle="modal"
                        data-bs-target={`#assigneeModal-${data.ID}`}
                    /></h5>

                    <div
                        className="modal fade"
                        id={`assigneeModal-${data.ID}`}
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                        tabIndex={-1}
                        role="dialog"
                        aria-labelledby="assigneeModalLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="assigneeModalLabel">
                                        Assignee Details
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">

                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap table-hover">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Name</th>
                                                    <th>Role</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {users.map((user, userIndx) => {
                                                    const isChecked = assignedUsers.includes(String(user.USER_ID));

                                                    return (
                                                        <tr key={user.USER_ID}>
                                                            <td>
                                                                <input
                                                                    type='checkbox'
                                                                    checked={isChecked}
                                                                    onChange={() => {
                                                                        setAssignedUsers(prev => {
                                                                            const userId = String(user.USER_ID); // Ensure string type
                                                                            const updated = isChecked
                                                                                ? prev.filter(id => id !== userId) // Remove
                                                                                : [...prev, userId];               // Add

                                                                            // Ensure uniqueness and all strings
                                                                            return Array.from(new Set(updated.map(String)));
                                                                        });
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>{user.FULL_NAME}</td>
                                                            <td>{user.ROLE_NAME}</td>
                                                        </tr>
                                                    );
                                                })}

                                            </tbody>
                                        </table>

                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <button className="btn btn-success" onClick={() => {
                                                saveAssignee(assignedUsers)
                                            }} >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul className="assigned-list">
                        {data.assignee && data.assignee.map((item, index) => {
                            const initials = item.FULL_NAME
                                .split(' ')
                                .map(word => word.charAt(0).toUpperCase())
                                .join('');

                            return (
                                <li key={index}>
                                    <span>{initials}</span>
                                </li>
                            );
                        })}

                    </ul>
                </div>
                {/* <div className="mod-box-info">
                    <h5>AA Plan Reference Number</h5>
                    <p />
                </div> */}
                <div className="mod-box-info">
                    <h5>Link Documents</h5>
                    <p />
                </div>

                <div>
                    <a
                        href={`${process.env.REACT_APP_BASE_URL}/v3/planApproval/download/:type/:planId`.replace(':type', 'pdf').replace(':planId', data?.ID)}
                        target='_blank'
                        className="btn btn-sm btn-primary me-2"
                        style={{
                            backgroundImage:
                                "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                        }}
                    >
                        <i className="fas fa-file label-icon" /> Export as PDF

                    </a>
                </div>

                <div className="plan-info-file">
                    <ul style={{ flexWrap: 'wrap' }}>
                        {(revisions || (revision ? [revision] : [])).map((rev, index) => {
                            const revId = rev?.ID;
                            const revFiles = (rev?.documents || []).map((doc, idx) => {
                                const rawFileName = doc.FILE_NAME || doc.fileName || '';
                                const encodedFileName = encodeURIComponent(rawFileName);
                                const displayName = doc.ORIGINAL_FILE_NAME || doc.originalFileName || rawFileName || `File ${idx + 1}`;
                                return {
                                    id: `${rawFileName || 'file'}-${idx}`,
                                    name: displayName,
                                    previewUrl: rawFileName && revId
                                        ? `${process.env.REACT_APP_BASE_URL}/v3/planApproval/document/preview/${data.ID}/${revId}/${encodedFileName}`
                                        : '',
                                    downloadUrl: rawFileName && revId
                                        ? `${process.env.REACT_APP_BASE_URL}/v3/planApproval/document/download/${data.ID}/${revId}/${encodedFileName}`
                                        : '',
                                    onDownload: rawFileName && revId
                                        ? () => handleDownloadFile(data.ID, revId, rawFileName)
                                        : null,
                                };
                            });

                            return (
                                <React.Fragment key={revId || index}>
                                    <li>
                                        <p>
                                            Revision <span> {rev?.REVISION_NAME}</span>
                                        </p>
                                    </li>
                                    <li>
                                        <div className="dropdown hover-dropdown">
                                            <p>
                                                Files{" "}
                                                <span
                                                    role="button"
                                                    className="dropdown-toggle"
                                                >
                                                    {rev?.documents?.length || 0} File <i className="bx bx-download" />
                                                </span>
                                            </p>
                                            {revFiles.length > 0 && (
                                                <FileDropdownPreviewMenu
                                                    files={revFiles}
                                                    onDownloadAll={() => {
                                                        if (data?.ID && revId) {
                                                            handleDownload(data.ID, revId);
                                                        }
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </li>
                                    {(rev?.REMARK || rev?.REMARKS) && (
                                        <li>
                                            <p>
                                                Remark <span> {rev?.REMARK || rev?.REMARKS}</span>
                                            </p>
                                        </li>
                                    )}
                                </React.Fragment>
                            );
                        })}
                        <li>
                            <p>
                                Owner’s Reference No <span>{data?.OWNER_CODE}</span>
                            </p>
                        </li>
                        <li>
                            <p>
                                Shipyard number <span>{data.SHIPYARD_CODE}</span>
                            </p>
                        </li>
                        <li>
                            <p>
                                Received Date <span>{moment(data.CREATED_ON).format('DD MMM YYYY')}</span>
                            </p>
                        </li>
                        <li>
                            <p>
                                Submitted Date {data?.SUBMITTED_DATE ? <span>{data?.SUBMITTED_DATE ? moment(data.SUBMITTED_DATE).format('DD MMM YYYY') : ''}</span> : ''}
                            </p>
                        </li>
                        {(data?.REMARK || data?.REMARKS) && (
                            <li>
                                <p>
                                    Remark <span>{data?.REMARK || data?.REMARKS}</span>
                                </p>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div >
    )
}

export default Header
